




import mixins from 'vue-typed-mixins'
import Nullable from '@mixins/NullableInput.vue'

export default mixins(Nullable).extend({})
